export const CARDS_MIN_LIMIT = 3;
export const DESKTOP_CARDS_MAX_LIMIT = 5;
export const ASPECT_RATIO = '3x2';
